
import { renderHtmlToReact } from '@src/utils/html';
import { Themed } from '@theme-ui/mdx';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Grid } from 'theme-ui';

const PageBannerWithImage = ({ image, color, vm, children }) => {
  const { t, i18n } = useTranslation();

  return (
    <Box className="page-banner page-banner--dim">
      <Box
        sx={{
          backgroundColor: color || 'white',
          position: 'absolute',
          overflow: 'hidden',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: '100vw',
        }}
      >
        <GatsbyImage
          className="page-banner__layer-image"
          loading="eager"
          image={image}
          alt=""
        />
      </Box>

      <Container
        p={4}
        sx={{
          display: 'flex',
          alignItems: 'end',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Grid columns={[1, 1, 1, 2]}>
          <Box>
            <Themed.h1 sx={{ lineHeight: 1.2, marginBottom: 3 }}>
              {vm.title}
            </Themed.h1>

            <Box sx={{ fontSize: [2, 3] }}>{vm.description}</Box>

            {children}
          </Box>
        </Grid>
      </Container>
    </Box>
  );
};

const DefaultBanner = ({ children, vm }) => {
  return (
    <Box className="page-banner page-banner--dim">
      <Container
        p={4}
        sx={{
          display: 'flex',
          alignItems: 'end',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Grid columns={[1, 1, 1, 2]}>
          <Box>{!!children && children}</Box>

          {!children && (
            <Box>
              <Themed.h1 sx={{ lineHeight: 1.2, marginBottom: 3 }}>
                {vm.title}
              </Themed.h1>

              <Box sx={{ fontSize: 3 }}>{vm.description}</Box>
            </Box>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

const pageBanner = ({ imageData, bgColor, title, description, children }) => {
  const image = getImage(imageData);

  const vm = {
    title: title,
    description: description && renderHtmlToReact(description),
  };

  if (image) {
    return (
      <PageBannerWithImage image={image} color={bgColor} vm={vm}>
        {children}
      </PageBannerWithImage>
    );
  } else {
    return <DefaultBanner vm={vm}>{children}</DefaultBanner>;
  }
};

export default pageBanner;
